import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';
import { schedulerApiUrl } from '../../../configs/settings';

export const SEND_NOTIFICATION_REQUEST = 'SEND_NOTIFICATION_REQUEST';
export const SEND_NOTIFICATION_SUCCESS = 'SEND_NOTIFICATION_SUCCESS';
export const SEND_NOTIFICATION_ERROR = 'SEND_NOTIFICATION_ERROR';

export const SEND_HOME_SCREEN_POPUP_REQUEST = 'SEND_HOME_SCREEN_POPUP_REQUEST';
export const SEND_HOME_SCREEN_POPUP_SUCCESS = 'SEND_HOME_SCREEN_POPUP_SUCCESS';
export const SEND_HOME_SCREEN_POPUP_ERROR = 'SEND_HOME_SCREEN_POPUP_ERROR';

export const CANCEL_NOTIFICATION_REQUEST = 'CANCEL_NOTIFICATION_REQUEST';
export const CANCEL_NOTIFICATION_SUCCESS = 'CANCEL_NOTIFICATION_SUCCESS';
export const CANCEL_NOTIFICATION_ERROR = 'CANCEL_NOTIFICATION_ERROR';

export const GET_LOG_BY_TITLE_REQUEST = 'GET_LOG_BY_TITLE_REQUEST';
export const GET_LOG_BY_TITLE_SUCCESS = 'GET_LOG_BY_TITLE_SUCCESS';
export const GET_LOG_BY_TITLE_ERROR = 'GET_LOG_BY_TITLE_ERROR';

export const GET_LOG_BY_ID_REQUEST = 'GET_LOG_BY_ID_REQUEST';
export const GET_LOG_BY_ID_SUCCESS = 'GET_LOG_BY_ID_SUCCESS';
export const GET_LOG_BY_ID_ERROR = 'GET_LOG_BY_ID_ERROR';

export const GET_CANBE_NOTIFIED_CUSTOMERS_REQUEST =
  'GET_CANBE_NOTIFIED_CUSTOMERS_REQUEST';
export const GET_CANBE_NOTIFIED_CUSTOMERS_SUCCESS =
  'GET_CANBE_NOTIFIED_CUSTOMERS_SUCCESS';
export const GET_CANBE_NOTIFIED_CUSTOMERS_ERROR =
  'GET_CANBE_NOTIFIED_CUSTOMERS_ERROR';

export const FETCH_NOTIFICATION_REQUEST = 'FETCH_NOTIFICATION_REQUEST';
export const FETCH_NOTIFICATION_SUCCESS = 'FETCH_NOTIFICATION_SUCCESS';
export const FETCH_NOTIFICATION_ERROR = 'FETCH_NOTIFICATION_ERROR';

export const FETCH_NOTIFICATION_V2_REQUEST = 'FETCH_NOTIFICATION_V2_REQUEST';
export const FETCH_NOTIFICATION_V2_SUCCESS = 'FETCH_NOTIFICATION_V2_SUCCESS';
export const FETCH_NOTIFICATION_V2_ERROR = 'FETCH_NOTIFICATION_V2_ERROR';

export const FETCH_EVENT_V2_REQUEST = 'FETCH_EVENT_V2_REQUEST';
export const FETCH_EVENT_V2_SUCCESS = 'FETCH_EVENT_V2_SUCCESS';
export const FETCH_EVENT_V2_ERROR = 'FETCH_EVENT_V2_ERROR';

export const FETCH_NOTIFICATION_DETAIL_LIST_REQUEST =
  'FETCH_NOTIFICATION_DETAIL_LIST_REQUEST';
export const FETCH_NOTIFICATION_DETAIL_LIST_SUCCESS =
  'FETCH_NOTIFICATION_DETAIL_LIST_SUCCESS';
export const FETCH_NOTIFICATION_DETAIL_LIST_ERROR =
  'FETCH_NOTIFICATION_DETAIL_LIST_ERROR';

export const GET_NOTIFICATION_V2_CAMPAIGN_REQUEST =
  'GET_NOTIFICATION_V2_CAMPAIGN_REQUEST';
export const GET_NOTIFICATION_V2_CAMPAIGN_SUCCESS =
  'GET_NOTIFICATION_V2_CAMPAIGN_SUCCESS';
export const GET_NOTIFICATION_V2_CAMPAIGN_ERROR =
  'GET_NOTIFICATION_V2_CAMPAIGN_ERROR';

export const GET_NOTIFICATION_V2_SEND_LOGS_REQUEST =
  'GET_NOTIFICATION_V2_SEND_LOGS_REQUEST';
export const GET_NOTIFICATION_V2_SEND_LOGS_SUCCESS =
  'GET_NOTIFICATION_V2_SEND_LOGS_SUCCESS';
export const GET_NOTIFICATION_V2_SEND_LOGS_ERROR =
  'GET_NOTIFICATION_V2_SEND_LOGS_ERROR';

export const SEARCH_NOTIFICATION_V2_SEND_LOGS_REQUEST =
  'SEARCH_NOTIFICATION_V2_SEND_LOGS_REQUEST';
export const SEARCH_NOTIFICATION_V2_SEND_LOGS_SUCCESS =
  'SEARCH_NOTIFICATION_V2_SEND_LOGS_SUCCESS';
export const SEARCH_NOTIFICATION_V2_SEND_LOGS_ERROR =
  'SEARCH_NOTIFICATION_V2_SEND_LOGS_ERROR';

export const fetchNotification = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_NOTIFICATION_REQUEST, FETCH_NOTIFICATION_SUCCESS, FETCH_NOTIFICATION_ERROR],
      callAPI: () => ApiClient.post('admin/NotificationBatchLog/Search', data),
      payload: { data },
    }),
  );
};

export const fetchNotificationV2 = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_NOTIFICATION_V2_REQUEST,
        FETCH_NOTIFICATION_V2_SUCCESS,
        FETCH_NOTIFICATION_V2_ERROR,
      ],
      callAPI: () =>
        ApiClient.post(
          `${schedulerApiUrl}/api/v2/Notification/SearchCampaign`,
          data,
        ),
      payload: { data },
    }),
  );
};

export const fetchEventV2 = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_EVENT_V2_REQUEST,
        FETCH_EVENT_V2_SUCCESS,
        FETCH_EVENT_V2_ERROR,
      ],
      callAPI: () =>
        ApiClient.post(
          `${schedulerApiUrl}/api/Notification/SearchEvent`,
          data,
        ),
      payload: { data },
    }),
  );
};

export const fetchNotificationDetailList = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_NOTIFICATION_DETAIL_LIST_REQUEST, FETCH_NOTIFICATION_DETAIL_LIST_SUCCESS, FETCH_NOTIFICATION_DETAIL_LIST_ERROR],
      callAPI: () => ApiClient.post('admin/Notifications/Search', data),
      payload: { data },
    }),
  );
};

export const getNotificationBatchLogByTitle = title => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [GET_LOG_BY_TITLE_REQUEST, GET_LOG_BY_TITLE_SUCCESS, GET_LOG_BY_TITLE_ERROR],
      callAPI: () => ApiClient.get(`admin/NotificationBatchLog/GetByTitle?title=${title}`),
      payload: {},
    }),
  );
};

export const getNotificationBatchLogById = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [GET_LOG_BY_ID_REQUEST, GET_LOG_BY_ID_SUCCESS, GET_LOG_BY_ID_ERROR],
      callAPI: () => ApiClient.get(`admin/NotificationBatchLog/GetById?id=${id}`),
      payload: {},
    }),
  );
};

export const getNotificationCampaignV2 = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GET_NOTIFICATION_V2_CAMPAIGN_REQUEST,
        GET_NOTIFICATION_V2_CAMPAIGN_SUCCESS,
        GET_NOTIFICATION_V2_CAMPAIGN_ERROR,
      ],
      callAPI: () =>
        ApiClient.get(`${schedulerApiUrl}/api/v2/Notification/GetCampaign/${id}`),
      payload: { id },
    }),
  );
};

export const getNotificationV2SendLogs = (id, status) => dispatch => {
  const query = status ? `?status=${encodeURIComponent(status)}` : '';
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GET_NOTIFICATION_V2_SEND_LOGS_REQUEST,
        GET_NOTIFICATION_V2_SEND_LOGS_SUCCESS,
        GET_NOTIFICATION_V2_SEND_LOGS_ERROR,
      ],
      callAPI: () =>
        ApiClient.get(
          `${schedulerApiUrl}/api/v2/Notification/GetSendLogs/${id}${query}`,
        ),
      payload: { id, status },
    }),
  );
};

export const searchNotificationV2SendLogs = (id, data) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        SEARCH_NOTIFICATION_V2_SEND_LOGS_REQUEST,
        SEARCH_NOTIFICATION_V2_SEND_LOGS_SUCCESS,
        SEARCH_NOTIFICATION_V2_SEND_LOGS_ERROR,
      ],
      callAPI: () =>
        ApiClient.post(
          `${schedulerApiUrl}/api/v2/Notification/SearchSendLogs/${id}`,
          data,
        ),
      payload: { id, data },
    }),
  );
};

export const sendNotification = (data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [
        SEND_NOTIFICATION_REQUEST,
        SEND_NOTIFICATION_SUCCESS,
        SEND_NOTIFICATION_ERROR,
      ],
      callAPI: () => ApiClient.post('scheduler/Notification/Send', data),
      payload: { data, formId },
    }),
  );
};

export const CREATE_CAMPAIGN_REQUEST = 'CREATE_CAMPAIGN_REQUEST';
export const CREATE_CAMPAIGN_SUCCESS = 'CREATE_CAMPAIGN_SUCCESS';
export const CREATE_CAMPAIGN_ERROR = 'CREATE_CAMPAIGN_ERROR';

export const createCampaign = (data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [
        CREATE_CAMPAIGN_REQUEST,
        CREATE_CAMPAIGN_SUCCESS,
        CREATE_CAMPAIGN_ERROR,
      ],
      callAPI: () =>
        ApiClient.post(
          `${schedulerApiUrl}/api/v2/Notification/CreateCampaign`,
          data,
        ),
      payload: { data, formId },
    }),
  );
};

/** Stub — replace endpoint when Home Screen Popup API contract is available. */
export const sendHomeScreenPopup = (data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [
        SEND_HOME_SCREEN_POPUP_REQUEST,
        SEND_HOME_SCREEN_POPUP_SUCCESS,
        SEND_HOME_SCREEN_POPUP_ERROR,
      ],
      callAPI: () => ApiClient.post('admin/HomeScreenPopup/Send', data),
      payload: { data, formId },
    }),
  );
};

export const cancelScheduledJob = (jobId, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [
        CANCEL_NOTIFICATION_REQUEST,
        CANCEL_NOTIFICATION_SUCCESS,
        CANCEL_NOTIFICATION_ERROR,
      ],
      callAPI: () => ApiClient.post('scheduler/Notification/CancelScheduledJob?jobId=' + jobId),
      payload: { jobId, formId },
    }),
  );
};

export const getCanBeNotifiedCustomers = () => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GET_CANBE_NOTIFIED_CUSTOMERS_REQUEST,
        GET_CANBE_NOTIFIED_CUSTOMERS_SUCCESS,
        GET_CANBE_NOTIFIED_CUSTOMERS_ERROR,
      ],
      callAPI: () => ApiClient.get('admin/Notifications/GetCustomers'),
      payload: {},
    }),
  );
};

const initialState = {
  payload: {},
  data: {},
  response: {},
  error: {},
  errorMessage: '',
  successMessage: '',
};

export default function reducer(state = initialState, action) {
  const { payload, response, error, successMessage, errorMessage } = action;
  switch (action.type) {
    case SEND_NOTIFICATION_REQUEST:
    case CREATE_CAMPAIGN_REQUEST:
    case SEND_HOME_SCREEN_POPUP_REQUEST:
    case CANCEL_NOTIFICATION_REQUEST:
    case FETCH_NOTIFICATION_REQUEST:
    case FETCH_NOTIFICATION_V2_REQUEST:
    case FETCH_EVENT_V2_REQUEST:
    case FETCH_NOTIFICATION_DETAIL_LIST_REQUEST:
    case GET_LOG_BY_TITLE_REQUEST:
    case GET_LOG_BY_ID_REQUEST:
    case GET_NOTIFICATION_V2_CAMPAIGN_REQUEST:
    case GET_NOTIFICATION_V2_SEND_LOGS_REQUEST:
    case SEARCH_NOTIFICATION_V2_SEND_LOGS_REQUEST:
    case GET_CANBE_NOTIFIED_CUSTOMERS_REQUEST:
      return {
        ...state,
        payload,
        response: {},
        error: {},
        successMessage: '',
        errorMessage: '',
      };

    case GET_CANBE_NOTIFIED_CUSTOMERS_SUCCESS:
      return {
        ...state,
        data: { ...state.data, canBeNotifiedCustomers: response.data.data },
        response,
        successMessage,
      };

    case SEND_NOTIFICATION_SUCCESS:
    case CREATE_CAMPAIGN_SUCCESS:
    case SEND_HOME_SCREEN_POPUP_SUCCESS:
    case CANCEL_NOTIFICATION_SUCCESS:
      return {
        ...state,
        response,
        successMessage,
      };

    case FETCH_NOTIFICATION_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          items: response.data.data.items,
          pages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };

    case FETCH_NOTIFICATION_V2_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          v2Items: response.data.data.items,
          v2Pages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };

    case FETCH_EVENT_V2_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          eventV2Items: response.data.data.items,
          eventV2Pages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };

    case FETCH_NOTIFICATION_DETAIL_LIST_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          notifications: response.data.data.items,
          notificationPages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };

    case GET_LOG_BY_TITLE_SUCCESS:
    case GET_LOG_BY_ID_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          item: response.data.data,
        },
        response,
        successMessage,
      };

    case GET_NOTIFICATION_V2_CAMPAIGN_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          v2Campaign: response.data.data,
        },
        response,
        successMessage,
      };

    case GET_NOTIFICATION_V2_SEND_LOGS_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          v2SendLogs: response.data.data || [],
        },
        response,
        successMessage,
      };

    case SEARCH_NOTIFICATION_V2_SEND_LOGS_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          v2SendLogs: response.data.data.items,
          v2SendLogPages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };

    case SEND_NOTIFICATION_ERROR:
    case CREATE_CAMPAIGN_ERROR:
    case SEND_HOME_SCREEN_POPUP_ERROR:
    case CANCEL_NOTIFICATION_ERROR:
    case FETCH_NOTIFICATION_ERROR:
    case FETCH_NOTIFICATION_V2_ERROR:
    case FETCH_EVENT_V2_ERROR:
    case GET_LOG_BY_TITLE_ERROR:
    case GET_LOG_BY_ID_ERROR:
    case GET_NOTIFICATION_V2_CAMPAIGN_ERROR:
    case GET_NOTIFICATION_V2_SEND_LOGS_ERROR:
    case SEARCH_NOTIFICATION_V2_SEND_LOGS_ERROR:
    case GET_CANBE_NOTIFIED_CUSTOMERS_ERROR:
    case FETCH_NOTIFICATION_DETAIL_LIST_ERROR:
      return {
        ...state,
        payload,
        error,
        errorMessage,
      };
    default:
      return state;
  }
}
